export default __webpack_public_path__ + "ae328800bbb8bac2bbb0e28a08e19edf.coffee";